import React from "react";
import CommonTable from "./CommonTable";
import dayjs from "dayjs";
import { Space, Tag, Typography } from "antd";
import { hourlyOptions } from "../../IpEMR/Options/physioOptions";
import { capitalizeFirstLetter } from "../../../helpers/utility";
import tagStyles from "../../../styles/Custom/Tag.module.css";

const PositionChange = ({ data }) => {
  const columns = [
    {
      title: "Time Done",
      dataIndex: "process_time",
      key: "process_time",
      render: (value) => dayjs(value)?.format("DD, MMM hh:mm A"),
    },
  ];
  return (
    <div>
      {data?.map((item) => (
        <CommonTable
          data={item?.actions?.flat()}
          columns={columns}
          titleData={() => (
            <Space wrap align="start" style={{ width: "100%" }}>
              <Typography style={{ fontWeight: "lighter" }}>
                {hourlyOptions?.find(
                  (option) =>
                    option?.value ===
                    item?.data?.do_data?.position_change_schedule
                )?.label || "-"}
              </Typography>
              <Tag className={tagStyles.smRndTag} color="blue">
                Advised by {capitalizeFirstLetter(item?.advised_by)}
              </Tag>
            </Space>
          )}
        />
      ))}
    </div>
  );
};

export default PositionChange;
